import { useState } from 'react'
import { Button, Group, Radio, Stack, Text, Textarea } from '@mantine/core'

// #1127 admin 応募詳細の遷移操作。Rails の form_with(POST /admin/applications/:id/transition)の内側に置き、
// name="status" のラジオと name="note" の textarea を通常のフォーム送信に乗せる。
// options は現在ステータスから遷移図上で遷移できるものだけがサーバー側で渡される(終端なら空)。
// Select は Mantine v9.5.2 でドロップダウンが開かない疑いがある(see memory: mantine_v9_broken_components)ため、
// フローティング UI を使わない Radio.Group で提示する。
export default function AdminJobApplicationTransitionForm({ currentStatusLabel, options = [] }) {
  const [status, setStatus] = useState('')

  if (options.length === 0) {
    return (
      <Text c="dimmed" fz="sm">
        現在のステータス「{currentStatusLabel}」からは遷移できません。
      </Text>
    )
  }

  return (
    <Stack gap="md">
      <Radio.Group
        name="status"
        label={`「${currentStatusLabel}」から変更する`}
        value={status}
        onChange={setStatus}
      >
        <Group mt="xs" gap="md" wrap="wrap">
          {options.map((option) => (
            <Radio key={option.value} value={option.value} label={option.label} />
          ))}
        </Group>
      </Radio.Group>

      <Textarea
        name="note"
        label="内部メモ"
        description="Bizlink 管理者のみ閲覧できます。応募者・企業には通知されません。"
        placeholder="任意"
        autosize
        minRows={3}
        maxRows={8}
      />

      <Group justify="flex-end">
        <Button type="submit" disabled={!status}>
          ステータスを変更する
        </Button>
      </Group>
    </Stack>
  )
}
